import script from "./WCUserGreetingV2.vue?vue&type=script&setup=true&lang=js"
export * from "./WCUserGreetingV2.vue?vue&type=script&setup=true&lang=js"

import "./WCUserGreetingV2.vue?vue&type=style&index=0&id=6691c646&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6691c646"]])

export default __exports__